"use client"

import { useMutation } from "@tanstack/react-query"
import {
  connectWhatsappAction,
  type ConnectedWhatsappChannel,
} from "@/server-actions/whatsapp-connect"
import { withQueryHandling } from "@/lib/with-query-handling"
import type { EmbeddedSignupFlow } from "@/lib/agents/messaging/channels/whatsapp/embedded-signup"

export type ConnectWhatsappInput = {
  agentId: string
  code: string
  /** Null on the coexistence flow — the server resolves it from the WABA. */
  phoneNumberId: string | null
  wabaId: string
  /** Which signup screen finished. Advisory: the server re-checks via Graph. */
  flow?: EmbeddedSignupFlow
}

/**
 * Completes Embedded Signup on the server (exchange code → register → subscribe →
 * create channel). The channel list is refreshed by the caller's onConnected
 * (channel-settings owns that legacy refresh), so there's nothing to invalidate here.
 */
export function useConnectWhatsappMutation() {
  return useMutation({
    mutationFn: async (input: ConnectWhatsappInput): Promise<ConnectedWhatsappChannel> => {
      const result = await withQueryHandling(connectWhatsappAction(input), {
        loading: "Connecting WhatsApp…",
        success: "WhatsApp connected",
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
